import styled from 'styled-components';
import { GRUNDFOS_BLUE, BLUE1, BLUE3, ATTENTION_BLUE } from '../../../constants/colors';
import { FONT_FAMILY, FONT_SIZE } from '../../../constants/fonts';
import { MEDIA } from '../../../constants/breakpoints';

export const HubWelcome = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: safe center;
  padding: 32px 24px;
  background: transparent;
  text-align: center;
  max-width: 800px;
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;
  overflow-y: auto;

  ${MEDIA.MOBILE} {
    padding: 24px 20px;
    justify-content: flex-start;
  }
`;

export const HubWelcome__Logo = styled.img`
  width: clamp(80px, 10vw, 120px);
  height: clamp(80px, 10vh, 120px);
  margin-bottom: clamp(20px, 2vw, 32px);
  opacity: 0.9;
`;

export const HubWelcome__Title = styled.h1`
  color: ${GRUNDFOS_BLUE};
  font-family: ${FONT_FAMILY.BOLD};
  font-size: clamp(26px, 4.5vw, 36px);
  margin: 0 0 16px 0;
  line-height: 1.2;

  ${MEDIA.MOBILE} {
    margin: 0 0 12px 0;
    padding: 0 8px;
  }
`;

export const HubWelcome__Message = styled.p`
  color: ${BLUE3};
  font-family: ${FONT_FAMILY.REGULAR};
  font-size: clamp(16px, 2.2vw, 20px);
  line-height: 1.6;
  max-width: 550px;
  margin: 0 0 32px 0;
  text-align: center;

  ${MEDIA.MOBILE} {
    padding: 0 8px;
  }
`;

export const HubWelcome__Disclaimer = styled.div`
  max-width: 620px;
  margin: 0 0 32px 0;
  padding: 14px 16px;
  background: ${BLUE1};
  border-left: 4px solid ${ATTENTION_BLUE};
  border-radius: 8px;
  text-align: left;

  ${MEDIA.MOBILE} {
    margin: 0 8px 28px 8px;
    padding: 12px 14px;
  }
`;

export const HubWelcome__DisclaimerTitle = styled.p`
  margin: 0 0 6px 0;
  color: ${GRUNDFOS_BLUE};
  font-family: ${FONT_FAMILY.SEMI_BOLD};
  font-size: ${FONT_SIZE.MEDIUM};
  line-height: 1.4;
`;

export const HubWelcome__DisclaimerText = styled.p`
  margin: 0;
  color: ${BLUE3};
  font-family: ${FONT_FAMILY.REGULAR};
  font-size: ${FONT_SIZE.SMALL};
  line-height: 1.5;
`;

export const HubWelcome__Divider = styled.hr`
  width: 80px;
  border: none;
  border-top: 3px solid ${ATTENTION_BLUE};
  margin: 0 0 32px 0;
  border-radius: 2px;
`;

export const HubWelcome__Subtext = styled.p`
  color: ${BLUE3};
  font-family: ${FONT_FAMILY.REGULAR};
  font-size: ${FONT_SIZE.MEDIUM};
  line-height: 1.5;
  max-width: 500px;
  margin: 0 0 24px 0;
  text-align: center;

  ${MEDIA.MOBILE} {
    font-size: ${FONT_SIZE.SMALL};
    padding: 0 8px;
  }
`;

export const HubWelcome__Link = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: ${ATTENTION_BLUE};
  font-family: ${FONT_FAMILY.SEMI_BOLD};
  font-size: ${FONT_SIZE.MEDIUM};
  text-decoration: none;
  padding: 12px 24px;
  border-radius: 12px;
  background: ${BLUE1};
  transition: all 0.2s ease;

  &:hover {
    background: ${ATTENTION_BLUE};
    color: white;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(18, 106, 243, 0.3);
  }

  ${MEDIA.MOBILE} {
    font-size: ${FONT_SIZE.SMALL};
  }
`;
